import { UnsplashImage } from "@/lib/ai/types";
import { ExternalImage } from "@/types/media";
import { TreeNode } from "@/types/tree";

export function convertUnsplashImageToMediaInputValue(
  unsplashImage: UnsplashImage
): ExternalImage {
  return {
    id: -1,
    type: "external_image",
    url: unsplashImage.urls.regular || "",
    alt: unsplashImage.alt_description || "",
    caption: unsplashImage.description || ""
  };
}

export function findNodeById(section: TreeNode, nodeId: TreeNode["id"]): TreeNode | null {
  if (section.id === nodeId) {
    return section;
  }
  
  for (const child of section.children) {
    const found = findNodeById(child, nodeId);
    if (found) {
      return found;
    }
  }
  
  return null;
}
